import DeviceIcon from '@mui/icons-material/Bloodtype'
import DeviceList from './DeviceList'

export default {
  icon: DeviceIcon,
  list: DeviceList,
}
